// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
//import {
//    DxDataGrid,
//    DxColumn,
//    DxGrouping,
//    DxGroupPanel,
//    DxPager,
//    DxPaging,
//    DxSearchPanel,
//    DxColumnChooser,
//    DxColumnFixing,
//    DxFilterRow,
//    DxFormat,
//    DxExport,
//    DxScrolling
//} from 'devextreme-vue/data-grid';
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-carts-grid-page',
    // #endregion
    // #region Components
    components: {
        DxDataGrid: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx"*/ 'devextreme-vue/data-grid')).DxDataGrid;
        }),
        DxColumn: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxColumn;
        }),
        DxGrouping: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxGrouping;
        }),
        DxGroupPanel: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxGroupPanel;
        }),
        DxPager: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxPager;
        }),
        DxPaging: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxPaging;
        }),
        DxSearchPanel: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxSearchPanel;
        }),
        DxColumnChooser: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxColumnChooser;
        }),
        DxColumnFixing: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxColumnFixing;
        }),
        DxFilterRow: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxFilterRow;
        }),
        DxFormat: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxFormat;
        }),
        DxExport: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxExport;
        }),
        DxScrolling: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dx-grid"*/ 'devextreme-vue/data-grid')).DxScrolling;
        })
    },
    // #endregion
    // #region Properties
    data: () => ({
        isVisible: false,
        isLoading: false,
        currentRow: {},
        carts: []
    }),
    props: {
        cartType: {
            type: String,
            required: false,
            default: 'S'
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Core
    methods: {
        async loadData() {
            // #region Vars
            this.isLoading = true;
            // #endregion
            // #region Load
            try {
                let tParameter = {
                    precedence: 1,
                    cartType: this.cartType
                };
                //Get
                let tResult = await host.api.get(`commerce/carts`, { params: tParameter });
                //Load
                this.carts = tResult.data;
                this.isLoading = false;
            }
            catch (e) {
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                this.isLoading = false;
            }
            // #endregion
        },
        OnRefresh(event) {
            this.loadData();
        },
        async OnCreate() {
            if ((await host.actions.tryExecute('288a.commerce.cart.create', { cartType: this.cartType })).isSucceeded === true) {
                this.loadData();
            }
        },
        async renameCart(cart) {
            if ((await host.actions.tryExecute('288a.commerce.cart.rename', cart)).isSucceeded === true) {
                this.loadData();
            }
        },
        async deleteCart(cart) {
            if ((await host.actions.tryExecute('288a.commerce.cart.delete', cart)).isSucceeded === true) {
                this.loadData();
            }
        },
        async OnOrderListToCart(cart) {
            if ((await host.actions.tryExecute('288a.commerce.orderlist.toCart', cart)).isSucceeded === true) {
                this.loadData();
            }
        },
        async OnOrderListSend(cart) {
            if ((await host.actions.tryExecute('288a.commerce.orderlist.send', cart)).isSucceeded === true) {
                this.loadData();
            }
        },
        onSelectionChanged() {
            this.isVisible = true;
            this.currentRow = this.$refs['grdMain'].instance.getSelectedRowsData();
        },
        hideToolbar() {
            this.$refs['grdMain'].instance.clearSelection();
            this.isVisible = false;
        },
    }
    // #endregion
});
// #endregion
